import React, {memo} from "react"
import {PhaseModel} from "../types/types"

export const PhaseComponent = memo(function PhaseComponent(props: PhaseModel) {
    const {id, name, is_selected, onClick} = props

    return (
        <button onClick={() => onClick(id)} className={`${is_selected ? "energy-active-button" : ""}`}>
            {name}
        </button>
    )
})
